<template>
  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
    <v-card flat color="transparent">
      <v-card-title class="font-weight-bold q-message">{{ `${qNumber}. ${qMessage}` }}</v-card-title>
      <v-container class="pl-10">
        <v-chip label :color="answer.includes(q.text) ? 'primary' : ''" v-for="q in qList" :key="q.text" class="ma-2" @click="setAnswer(q.text)">{{ q.text }}</v-chip>
      </v-container>
    </v-card>
    <v-card-actions>
      <v-btn color="#5878b8" :disabled="!valid && this.isSkipped.filter((k) => k).length === 0" width="100" class="headline white--text" @click="confirm">
        확인
        <v-icon right>mdi-check</v-icon>
      </v-btn>
      <!-- <v-btn text color="grey" class="title" v-if="valid">
        Enter 키를 눌러주세요
        <v-icon>mdi-keyboard-return</v-icon>
      </v-btn> -->
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
export default {
  props: {
    qType: { type: String, default: '' },
    qCategory: { type: String, default: '' },
    target: {
      type: String,
      default: 'I',
    },
    qOption: {
      type: Object,
      default: () => {},
    },
    qList: {
      type: Array,
      default: () => [],
    },
    qId: {
      type: String,
      default: '',
    },
    qNumber: {
      type: String,
      default: 'qNumber',
    },
    qMessage: {
      type: String,
      default: '',
    },
    qTitle: {
      type: String,
      default: '',
    },
    qPredicate: {
      type: String,
      default: '',
    },
    emailType: {
      type: Boolean,
      default: false,
    },
    maxText: {
      type: Number,
      default: 10,
    },
  },
  mounted() {
    const ans = (this[this.qCategory.toLowerCase()] || {})[this.qId]
    // console.log(ans)
    if (ans) {
      this.isCompleted = true
      this.answer = ans.value.slice(0)
    }
  },
  data() {
    return {
      valid: true,
      answer: [],
      lazy: false,
      rules: {
        required: (value) => !!value || '꼭 써주셔야 합니다',
        counter: (value) => value.length <= 20 || '최대 20 글자까지 해주세요',
        emailRules: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    }
  },
  methods: {
    ...mapMutations(['setUserEmail', 'setUserNick', 'setMaster', 'setFinance', 'setLife', 'setCareer']),
    ...mapActions(['submit']),
    getRule(inputType) {
      const yearRegx = /^(19|20)[0-9]{2}$/
      const ageRegx = /^\d{2}$/
      const childRegx = /^[0-5]$/
      const emailRegx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      let val = []
      switch (inputType) {
        case 'year':
          val.push((v) => yearRegx.test(v) || '연도를 입력하세요')
          break
        case 'age':
          val.push((v) => ageRegx.test(v) || '나이를 입력하세요')
          break
        case 'children':
          val.push((v) => childRegx.test(v) || '최대 5명 숫자로 입력하세요')
          break
        default:
          return this.emailType ? [this.rules.required, this.rules.emailRules] : [this.rules.required]
      }
      return val
    },
    setAnswer(t) {
      console.log(this.answer)
      if (this.answer.length < 6) {
        if (this.answer.includes(t)) {
          const kk = this.answer.slice(0)
          this.answer = kk.filter((o) => o !== t)
        } else this.answer.push(t)
      } else if (this.answer.includes(t)) {
        const kk = this.answer.slice(0)
        this.answer = kk.filter((o) => o !== t)
      } else {
        alert('6개 이상 고를 수 없습니다')
      }
    },
    confirm() {
      ;(this.valid || this.isSkipped.filter((k) => k).length > 0) && this.$emit('nextSlide')
      const payload = {
        id: this.qId,
        question: this.qMessage,
        category: this.qCategory,
        type: this.qType,
        target: this.target,
        option: {
          count: this.preCount,
        },
        value: this.answer,
      }

      this.setCareer(payload)
      this.submit()
    },
  },
  computed: {
    ...mapState(['userEmail', 'userNick', 'master', 'currentYear', 'career']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'hasWife', 'getChildrenCount', 'getParentsCount']),
    byYear() {
      return [this.currentYear].concat(this.year.map((y) => y - 1))
    },
    list() {
      if ((this.qOption || {}).type === 'condition') {
        let count = 0
        if (this.qOption.key === 'childrenCount') count = this.getChildrenCount
        if (this.qOption.key === 'parentsCount') count = this.getParentsCount
        if (this.qOption.key === 'hasWife') count = this.hasWife ? 2 : 1
        return this.qList.slice(0, count)
      }
      if (this.qType === 'multi3') return this.qList.slice(0, this.preCount > 5 ? 5 : this.preCount)

      return this.qList
    },
  },
}
</script>

<style></style>
